import { instance, errorService } from '@/services/api'
import { masterAPIs, screenType } from '@/services/authConstantsV1'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import { calculateGridHeight, showNotification, customComparator } from '@/services/calculate'
import { gridProperties } from '@/services/column.config'
import Pagination from '@/components/DynamicComponents/Pagination'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: {
    tabKey: String,
    role: String,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      if (String(value).length > 100) {
        callback(
          new Error(
            'Building use must be less than or equals to 100 characters',
          ),
        )
      } else {
        callback()
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      defaultSortedBy: 'buildingUse',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      buildingUseList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        buildingUse: '',
        isActive: 1,
      },
      rules: {
        buildingUse: [
          {
            required: true,
            message: 'Please enter building use',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      spinner: false,
      selectedRowKeys: [],
      loadRefresh: false,
      gridOptions: null,
      columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      loading: true,
      filters: {},
      tableState: null,
    }
  },
  mounted() {
    this.$root.$on('deleteBuildingUse', this.deleteBuildingUse)
    this.$root.$on('editBuildingUse', this.getBuildingUseById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '3') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.loading = true
        this.buildingUseList = []
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
  },
  beforeDestroy() {
    this.$root.$off('deleteBuildingUse')
    this.$root.$off('editBuildingUse')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      }
      this.frameworkComponents = gridProperties.master.frameworks
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked) return false
          else return true
        }
      }
      this.columnDefs = gridProperties.master.columns.buildingUse
    },

    // Refresh Building Uses
    refreshBuildingUses() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.buildingUseList = []
      this.page = 0
      this.defaultSortedBy = 'buildingUse'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'buildingUse',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getBuildingUses(this.gridOptions)
    },

    // Add New Building Use
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Building Use'
      this.form.buildingUse = undefined
      this.form.id = undefined
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Get Building Use
    getBuildingUses(params, type) {
      instance
        .post(masterAPIs.buildingUse.list, {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          buildingUse: _.get(this.filters, 'buildingUse', undefined),
        })
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.buildingUseList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'proprtySubTypeTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.buildingUse.delete, ids)
        .then(response => {
          showNotification(
            'success',
            'Delete Building Use',
            'Building Use deleted successfully!',
          )
          this.refreshBuildingUses()
        })
        .catch(error => {
          errorService(error)
        })
    },

    // Delete All Building Uses
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected building uses ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              building uses
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Delete Building Uses
    deleteBuildingUse(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.buildingUse}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this building
              use
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      this.loading = true
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.structureProfileList = null
      if (sortData.length > 0) {
        this.defaultSortedBy =
          sortData[0]['colId'] === 'buildingUse'
            ? 'buildingUse'
            : sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'buildingUse'
        this.defaultSortOrder = true
      }
      this.buildingUseList = []
      this.getBuildingUses(this.gridOptions, 'sort')
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Get Building Use By Id
    getBuildingUseById(id) {
      this.visible = true
      this.modalTitle = 'Edit'
      this.spinner = true
      instance
        .get(masterAPIs.buildingUse.details(id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.buildingUse = _.get(
            response.data,
            'result.buildingUse',
            null,
          )
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Save Building Use
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          let url = masterAPIs.buildingUse.add
          let method = 'post'
          if (this.form.id) {
            method = 'patch'
            url = masterAPIs.buildingUse.details(this.form.id)
          }
          instance[method](url, {
            buildingUse: this.form.buildingUse,
          })
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                this.form.id ? 'Update Building Use' : 'Create Building Use',
                this.form.id
                  ? 'Building Use updated successfully!'
                  : 'Building Use created successfully!',
              )
              if (this.form.id) {
                const newData = [...this.buildingUseList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.buildingUseList = newData
              } else {
                this.getBuildingUses(this.tableParams)
              }
              this.$refs.ruleForm.resetFields()
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'proprtySubTypeTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.buildingUseList = []
      this.selectedRowKeys = []
      this.getBuildingUses(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.buildingUseList = []
      this.loading = true
      this.page = 0
      this.getBuildingUses(this.gridOptions)
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: screenType.buildingUse,
          columnDetails: JSON.stringify(this.tableState),
        }
        this.$emit('updateColumns', request)
      }
    },

    getColumnSettings(params) {
      if (this.role === 'Admin') {
        instance
          .get(masterAPIs.columnSetting.get(screenType.buildingUse))
          .then(response => {
            const tableState = _.get(response.data, 'result.columnDetails', null)
            this.setColumnSettings(params, tableState)
          })
          .catch(error => {
            this.spinner = false
            errorService(error)
          })
      } else {
        this.setColumnSettings(params)
      }
      this.getBuildingUses(params)
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = false
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'buildingUse'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'buildingUse',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin',
            },
            {
              colId: 'isActive',
              hide: this.role !== 'Admin',
            },
            {
              colId: '0',
              hide: this.role !== 'Admin',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
